import {SponsorButton} from '@github-ui/repo-sponsor-button'
import {useSponsorData} from '@github-ui/repo-sponsor-button/hooks/use-sponsor-data'

interface HeaderSponsorButtonProps {
  ownerLogin: string
  repoName: string
  repoNameWithOwner: string
  /** Whether the repo owner is an org (used for square avatar in sponsor dialog). */
  isOrgOwned?: boolean
  /** When true, auto-opens the dialog if data supports it (multiple sponsors or external links). */
  defaultOpen?: boolean
}

/**
 * Lazily fetches sponsor data and renders the SponsorButton.
 * Uses the shared useSponsorData hook (non-suspending) so the header
 * doesn't block rendering while sponsor data loads.
 */
export function HeaderSponsorButton({
  ownerLogin,
  repoName,
  repoNameWithOwner,
  isOrgOwned,
  defaultOpen,
}: HeaderSponsorButtonProps) {
  const {sponsorData} = useSponsorData({ownerLogin, repoName, isOrgOwned})

  return (
    <SponsorButton
      show
      repoNameWithOwner={repoNameWithOwner}
      sponsorables={sponsorData?.sponsorables}
      externalFundingLinks={sponsorData?.externalFundingLinks}
      defaultOpen={defaultOpen}
    />
  )
}
